import {Animation} from '@/components/ui/animation/Animation'
import {Button} from '@/components/ui/button/Button'
import {Modal} from '@/components/ui/modal/Modal'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useRootStore} from '@/store'
import {selectGoalDeletionSuccessModal} from '@/store/selectors'
import Cancel from '@assets/animations/Alert-2.json'
import {useTranslation} from 'react-i18next'
import {StyledAnimation, StyledBody, StyledButtonSection, StyledStopButton, StyledText} from './style'
import useMixPanel from '@/integrations/mixpanel/hooks/useMixpanel'
import {MixpanelEventNameE} from '@/integrations/mixpanel/types'
import {useFetchSupporters} from '../../queries/useFetchSupporters'
import {useStopGoalV3} from '../../queries/useStopGoalV3'
import {GoalV3} from '@/features/chat/chat.model'
import {GOAL_MODEL_V3} from '../../services/goal.schema'
import {MediaTypeE} from '@/types'

type StopGoalModalProps = {
    onClose: () => void
    onStopGoalClick: () => void
    goalId?: number
}
export const StopGoalModal = ({onClose, onStopGoalClick, goalId}: StopGoalModalProps) => {
    const {t} = useTranslation()
    const {openModal} = useRootStore(selectGoalDeletionSuccessModal)
    const {data: supporters} = useFetchSupporters(`${goalId}`)
    const mixpanel = useMixPanel()

    const onSuccess = (data: GoalV3) => {
        onStopGoalClick()
        openModal(true)
        mixpanel?.trackEvent(MixpanelEventNameE.GoalCancelled, {
            goal_name: data?.[GOAL_MODEL_V3.Name],
            goal_amount: data?.[GOAL_MODEL_V3.TargetAmount].toString(),
            goal_type: data?.type?.type,
            goal_end_date: data?.[GOAL_MODEL_V3.EndDate].toString(),
            proof_type: {
                has_image_proof: data?.[GOAL_MODEL_V3.HasImageProof],
                has_video_proof: data?.[GOAL_MODEL_V3.HasVideoProof]
            },
            images_count: data?.media?.filter(item => item?.type === MediaTypeE.IMAGE)?.length,
            videos_count: data?.media?.filter(item => item?.type === MediaTypeE.VIDEO)?.length,
            number_of_supporters: supporters?.length,
            cancelled_reason: data?.cancelledReason
        })
    }

    const {mutate: cancelGoal, isPending} = useStopGoalV3(onSuccess)

    return (
        <Modal onClose={onClose} minHeight={'557px'} title={t('stop_goal_popup:title')}>
            {isPending && <Spinner />}
            <StyledBody>
                <StyledAnimation>
                    <Animation animationData={Cancel} />
                </StyledAnimation>
                <StyledText>
                    <span>{t('stop_goal_popup:subtitle')}</span>
                    <p>{t('stop_goal_popup:description')}</p>
                </StyledText>
                <StyledButtonSection>
                    <Button
                        variant="warning"
                        onClick={() => {
                            if (goalId) cancelGoal({goalId: goalId.toString()})
                        }}
                    >
                        {t('stop_goal_popup:button_text')}
                    </Button>
                    <StyledStopButton onClick={onClose}>{t('stop_goal_popup:bottom_button_text')}</StyledStopButton>
                </StyledButtonSection>
            </StyledBody>
        </Modal>
    )
}
